import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'integer',
    standalone: false
})
export class IntegerPipe implements PipeTransform {

    static format(integer: string): string {
        return integer?.split('.')[0] ?? '';
    }
    /**
     * Format number to integer
     */
    transform(integer: string): string {
        return IntegerPipe.format(integer);
    }

}
